import React, { useState } from 'react';
import styled from 'styled-components';

import { HeadModul, ModulContainer } from 'components/Main/table/TableStyles';
import { usePortalContext } from 'context/PortalContext';
import { IoMdClose } from 'react-icons/io';
import { useCampaignContext } from 'context/CampaignContext';
// import { add, get, set } from 'lodash'; // Removed - not used
import { DarkButton } from 'components/style/Global';
import { API } from 'aws-amplify';
import {
  addUmbrellaChildCampaign,
  deleteUmbrellaChildCampaign,
  saveUmbrellaCampaigns,
  // updateCampaign, // Removed - not used
  updateCampaign_V2,
  updateUmbrellaCampaign,
} from 'graphql/mutations';
import {
  DeleteUmbrellaChildCampaignMutation,
  SaveUmbrellaCampaignsMutation,
  UpdateCampaignMutation,
  UpdateCampaign_V2Mutation,
  UpdateCampaign_V2MutationVariables,
} from 'API';
import { useSearchParams } from 'react-router-dom';
import { useClientCode } from 'customHooks/useParameters';
import { CustomSelect } from 'components/Header/CampaignSelectComponent';
import { useClientContext } from 'context/ClientContext';
// import AuthContext from 'context/AuthContext'; // Removed - not used

type Props = {};

const Modal = styled.div`
  position: fixed; /* Stay in place */
  z-index: 20; /* Sit on top */
  padding: 50px 0; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  display: flex;
  justify-content: center;

  h1 {
    text-align: center;
    font-size: 20px;
    font-weight: normal;
    margin-bottom: 50px;
  }
  .styleToFit {
    z-index: unset;
  }
`;

const InputContainer = styled.form`
  display: flex;
  flex-direction: column;
  width: fit-content;
  min-width: 600px;
  margin-bottom: 1.3vw;

  input,
  select,
  textarea {
    font-size: 12px;
    font-family: 'fontRegular';
    padding: 8px;
    border-radius: 7px;
    border: 1px solid ${({ theme }) => theme.border};
    color: ${({ theme }) => theme.primaryGray};
    background-color: ${({ theme }) => theme.background};
  }
  textarea:focus,
  input:focus {
    outline: 1px solid ${({ theme }) => theme.border};
  }
  textarea {
    resize: none;
    min-height: 100px;
  }

  option {
    font-size: 12px;
  }

  label {
    font-size: 12px;
    color: ${({ theme }) => theme.primaryGray};
  }

  span {
    font-size: 12px;
    padding: 3px;
    color: red;
    display: none;
  }
  input:invalid[focused-name='true'] {
    outline: 1px solid red;
  }
  input:invalid[focused-name='true'] ~ span {
    display: block;
  }
  h3 {
    font-size: 18px;
    color: ${({ theme }) => theme.secondaryGray};
    font-family: 'fontRegular';
    font-weight: normal;
  }
`;

const UmbrellaContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 7px;
  padding: 1vw;
  margin-bottom: 1.3vw;
  background-color: ${({ theme }) => theme.background};
`;

const UmbrellaTitle = styled.h3`
  font-size: 14px;
  color: ${({ theme }) => theme.primaryGray};
  font-family: 'fontRegular';
  font-weight: 600;
  margin: 0 0 1vw 0;
`;

const RadioContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5vw;
  margin-bottom: 1vw;
`;

const RadioOption = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  input[type='radio'] {
    margin-right: 8px;
    cursor: pointer;
  }

  label {
    font-size: 12px;
    color: ${({ theme }) => theme.primaryGray};
    cursor: pointer;
    font-family: 'fontRegular';
  }
`;

const UmbrellaInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1vw;
  width: 100%;

  label {
    font-size: 12px;
    color: ${({ theme }) => theme.primaryGray};
    margin-bottom: 0.5vw;
    font-family: 'fontRegular';
  }

  input,
  select {
    font-size: 12px;
    font-family: 'fontRegular';
    padding: 8px;
    border-radius: 7px;
    border: 1px solid ${({ theme }) => theme.border};
    color: ${({ theme }) => theme.primaryGray};
    background-color: ${({ theme }) => theme.background};
    width: 100%;
    box-sizing: border-box;
  }

  input:focus,
  select:focus {
    outline: 1px solid ${({ theme }) => theme.border};
  }
`;

const EditCampaignModal = (props: Props) => {
  const { setEditCampaign } = usePortalContext();
  // const { user } = useContext(AuthContext); // Removed - not used
  const { activeCampaign, campaignList } = useCampaignContext();
  const [updateCampaignVariables, setUpdateCampaignVariables] = useState<any>({});
  const [responseMessage, setResponseMessage] = useState<any>();
  const [searchParams, setSearchParams] = useSearchParams();
  const { anyPublish, activeOrganization } = useClientContext();
  const [getID, setID] = useClientCode();

  // State for umbrella campaign choice
  const [umbrellaChoice, setUmbrellaChoice] = useState<'none' | 'existing' | 'new'>('none');

  const activeCampaignClientandCountry = {
    Code: activeCampaign?.ClientCode,
    Country: activeCampaign?.ClientCountry,
    Organization_id: activeOrganization?.OrganizationId,
  };

  const [newUmbrellaCampaign, setNewUmbrellaCampaign] = useState({
    Name: 'New Umbrella Campaign',
    Client: activeCampaignClientandCountry,
    Campaigns: [activeCampaign?.campaignId],
  });

  // Removed handleDiscard - no longer needed with simplified UI

  async function addChildrenToUmbrellaCampaign(umbrellaID: number, children: number[]) {
    console.log('children', children);
    console.log('umbrellaID', umbrellaID);
    try {
      const res = await API.graphql({
        query: addUmbrellaChildCampaign,
        variables: {
          ID: umbrellaID,
          Campaigns: children,
        },
        authMode: 'AMAZON_COGNITO_USER_POOLS',
      });
      setResponseMessage('Success');
      searchParams.delete('campaignID');
      setSearchParams(searchParams);
      setID('none');
      setTimeout(() => {
        setResponseMessage(undefined);
        setEditCampaign(false);
        setID(getID);
      }, 1500);
    } catch (error) {
      console.error('error adding children to umbrella campaign', error);
    }
  }

  async function deleteChildrenFromUmbrellaCampaign(umbrellaID: number, children: number[]) {
    try {
      const res = (await API.graphql({
        query: deleteUmbrellaChildCampaign,
        variables: {
          ID: umbrellaID,
          Campaigns: children,
        },
        authMode: 'AMAZON_COGNITO_USER_POOLS',
      })) as { data: DeleteUmbrellaChildCampaignMutation };
      setResponseMessage('Success');
      searchParams.delete('campaignID');
      setSearchParams(searchParams);
      setID('none');
      setTimeout(() => {
        setResponseMessage(undefined);
        setEditCampaign(false);
        setID(getID);
      }, 1500);
    } catch (error) {
      console.error('error adding children to umbrella campaign', error);
    }
  }

  async function handleUpdateCampaign(updateCampaignVariables: any) {
    const { UmbrellaCampaign, ...rest } = updateCampaignVariables;

    if (activeCampaign?.campaignId.toString().startsWith('100')) {
      const removedCampaigns = existingUmbrellaCampaignProperties?.childCampaigns.filter(
        (campaign: any) => campaign.removed,
      );
      const addedCampaigns = existingUmbrellaCampaignProperties?.addedCampaigns;
      if (removedCampaigns.length > 0) {
        deleteChildrenFromUmbrellaCampaign(
          activeCampaign?.campaignId as number,
          removedCampaigns.map((campaign: any) => campaign.ID),
        );
      }
      if (addedCampaigns.length > 0) {
        addChildrenToUmbrellaCampaign(
          activeCampaign?.campaignId as number,
          addedCampaigns.map((campaign: any) => campaign.ID),
        );
      }
      if (rest && rest.Name) {
        try {
          const response = (await API.graphql({
            query: updateUmbrellaCampaign,
            variables: {
              ID: activeCampaign?.campaignId,
              Name: rest.Name,
            },
            authMode: 'AMAZON_COGNITO_USER_POOLS',
          })) as { data: UpdateCampaignMutation };
          const message = response.data.updateCampaign?.message;
          setResponseMessage(message);
          searchParams.delete('campaignID');
          setSearchParams(searchParams);
          setID('none');
          setTimeout(() => {
            setResponseMessage(undefined);
            setEditCampaign(false);
            setID(getID);
          }, 1500);
        } catch (error) {
          console.error('updateCampaign error', error);
        }
      }

      //1) updateUmbrellaCampaignName
    } else {
      // IF I AM ON A STANDARD CAMPAIGN AND I AM ADDING IT TO AN UMBRELLA CAMPAIGN
      if (UmbrellaCampaign) {
        if (newUmbrellaCampaign.Name === 'New Umbrella Campaign') {
          addChildrenToUmbrellaCampaign(Number(UmbrellaCampaign), [activeCampaign?.campaignId as number]);
        } else if (newUmbrellaCampaign.Name !== 'New Umbrella Campaign') {
          console.log(newUmbrellaCampaign);

          try {
            const response = (await API.graphql({
              query: saveUmbrellaCampaigns,
              variables: newUmbrellaCampaign,
              authMode: 'AMAZON_COGNITO_USER_POOLS',
            })) as { data: SaveUmbrellaCampaignsMutation };

            const message = response.data?.saveUmbrellaCampaigns?.ID;
            setResponseMessage('Umbrella Campaign Created with ID: ' + message);
            searchParams.delete('campaignID');
            setSearchParams(searchParams);
            setID('none');
            setTimeout(() => {
              setID(getID);
            }, 1500);
          } catch (error) {
            console.log('error adding new campaign', error);
          }
        }
      } else if (rest) {
        try {
          const response = (await API.graphql({
            query: updateCampaign_V2,
            variables: {
              CampaignId: Number(activeCampaign?.campaignId),
              // clientCode: activeCampaign?.ClientCode,
              // clientCountry: activeCampaign?.ClientCountry,
              ...updateCampaignVariables,
            } as UpdateCampaign_V2MutationVariables,
            authMode: 'AMAZON_COGNITO_USER_POOLS',
          })) as { data: UpdateCampaign_V2Mutation };
          const message = response.data.updateCampaign_V2?.message;
          setResponseMessage(message);
          searchParams.delete('campaignID');
          setSearchParams(searchParams);
          setID('none');
          setTimeout(() => {
            setResponseMessage(undefined);
            setEditCampaign(false);
            setID(getID);
          }, 3500);
        } catch (error) {
          console.error('updateCampaign error', error);
        }
      }
    }
  }

  const isUmbrellaCampaign = activeCampaign?.campaignId.toString().startsWith('100');
  const umbrellaCampaigns = campaignList
    ?.filter((campaign) => campaign?.campaignId.toString().startsWith('100'))
    .map((campaign) => {
      return {
        ID: campaign?.campaignId,
        Name: campaign?.campaign,
        ClientCode: campaign?.ClientCode,
        ClientCountry: campaign?.ClientCountry,
      };
    });

  const EditStandardCampaign = (
    <UmbrellaContainer>
      <UmbrellaTitle>Umbrella Campaign Options</UmbrellaTitle>

      {/* Radio button choices */}
      <RadioContainer>
        <RadioOption>
          <input
            type="radio"
            name="umbrellaChoice"
            value="none"
            checked={umbrellaChoice === 'none'}
            onChange={(e) => {
              setUmbrellaChoice('none');
              const newVars = { ...updateCampaignVariables };
              delete newVars.UmbrellaCampaign;
              setUpdateCampaignVariables(newVars);
            }}
          />
          <label>Keep this campaign standalone (no umbrella)</label>
        </RadioOption>

        <RadioOption>
          <input
            type="radio"
            name="umbrellaChoice"
            value="existing"
            checked={umbrellaChoice === 'existing'}
            onChange={(e) => setUmbrellaChoice('existing')}
          />
          <label>Add to existing umbrella campaign</label>
        </RadioOption>

        <RadioOption>
          <input
            type="radio"
            name="umbrellaChoice"
            value="new"
            checked={umbrellaChoice === 'new'}
            onChange={(e) => setUmbrellaChoice('new')}
          />
          <label>Create new umbrella campaign</label>
        </RadioOption>
      </RadioContainer>

      {/* Conditional inputs based on choice */}
      {umbrellaChoice === 'existing' && (
        <UmbrellaInputContainer>
          <label>Select existing umbrella campaign:</label>
          <select
            onChange={(e) =>
              setUpdateCampaignVariables({
                ...updateCampaignVariables,
                UmbrellaCampaign: e.target.value,
              })
            }
          >
            <option value="" disabled selected>
              Choose umbrella campaign...
            </option>
            {umbrellaCampaigns?.map((campaign) => (
              <option key={campaign.ID} value={campaign.ID}>
                ({campaign.ID}) {campaign.Name} - {campaign.ClientCode}
              </option>
            ))}
          </select>
        </UmbrellaInputContainer>
      )}

      {umbrellaChoice === 'new' && (
        <UmbrellaInputContainer>
          <label>New umbrella campaign name:</label>
          <input
            onChange={(e) => {
              setUpdateCampaignVariables({
                ...updateCampaignVariables,
                UmbrellaCampaign: e.target.value,
              });
              setNewUmbrellaCampaign({ ...newUmbrellaCampaign, Name: e.target.value });
            }}
            type="text"
            placeholder="Enter new umbrella campaign name..."
          />
        </UmbrellaInputContainer>
      )}
    </UmbrellaContainer>
  );

  const [existingUmbrellaCampaignProperties, setExistingUmbrellaCampaignProperties] = useState<any>(
    isUmbrellaCampaign
      ? {
          ID: activeCampaign?.campaignId,
          Name: activeCampaign?.campaign,
          ClientCode: activeCampaign?.ClientCode,
          childCampaigns: activeCampaign?.childCampaigns?.map((campaign) => {
            return {
              ID: campaign?.campaignId,
              Name: campaign?.campaign,
              ClientCode: campaign?.ClientCode,
              removed: false,
            };
          }),
          addedCampaigns: [],
        }
      : null,
  );

  const EditUmbrellaCampaign = (
    <div>
      <div style={{ display: 'flex', flexDirection: 'column', padding: '1vw  2vw 0 1vw' }}>
        <InputContainer>
          <label>Campaign Name</label>
          <input
            onChange={(e) => {
              setExistingUmbrellaCampaignProperties({
                ...existingUmbrellaCampaignProperties,
                Name: e.target.value,
              });
              setUpdateCampaignVariables({ ...updateCampaignVariables, Name: e.target.value });
            }}
            type="text"
            value={existingUmbrellaCampaignProperties?.Name}
          />
        </InputContainer>

        <InputContainer>
          <label>Remove Child Campaign</label>
          <CustomSelect
            className="styleToFit"
            placeholder="Select Campaign(s)"
            isMulti
            options={existingUmbrellaCampaignProperties?.childCampaigns.map((e: any) => {
              return {
                value: e.ID,
                label: `(${e.ID}) ${e.Name} - ${e.ClientCode}`,
              };
            })}
            onChange={(e: any, actionMeta: any) => {
              if (actionMeta.action === 'remove-value') {
                setExistingUmbrellaCampaignProperties({
                  ...existingUmbrellaCampaignProperties,
                  childCampaigns: existingUmbrellaCampaignProperties?.childCampaigns.map((campaign: any) => {
                    if (campaign.ID === actionMeta.removedValue.value) {
                      return { ...campaign, removed: false };
                    }
                    return campaign;
                  }),
                });
              } else if (actionMeta.action === 'select-option') {
                setExistingUmbrellaCampaignProperties({
                  ...existingUmbrellaCampaignProperties,
                  childCampaigns: existingUmbrellaCampaignProperties?.childCampaigns.map((campaign: any) => {
                    if (campaign.ID === actionMeta.option.value) {
                      return { ...campaign, removed: true };
                    }
                    return campaign;
                  }),
                });
              } else if (actionMeta.action === 'clear') {
                setExistingUmbrellaCampaignProperties({
                  ...existingUmbrellaCampaignProperties,
                  childCampaigns: existingUmbrellaCampaignProperties?.childCampaigns.map((campaign: any) => {
                    return { ...campaign, removed: false };
                  }),
                });
              }
            }}
          ></CustomSelect>
        </InputContainer>

        <InputContainer>
          <label>Add Child Campaign</label>
          <CustomSelect
            className="styleToFit"
            placeholder="Select Campaign(s)"
            isMulti
            options={campaignList
              ?.filter((campaign) => campaign?.ClientCode === activeCampaign?.ClientCode)
              .filter((campaign) => !campaign?.campaignId.toString().startsWith('100'))
              .map((campaign) => {
                return {
                  value: campaign?.campaignId,
                  label: `(${campaign?.campaignId}) ${campaign?.campaign} - ${campaign?.ClientCode}`,
                };
              })}
            onChange={(e: any, actionMeta: any) => {
              if (actionMeta.action === 'remove-value') {
                setExistingUmbrellaCampaignProperties({
                  ...existingUmbrellaCampaignProperties,
                  addedCampaigns: existingUmbrellaCampaignProperties?.addedCampaigns.filter(
                    (campaign: any) => campaign.ID !== actionMeta.removedValue.value,
                  ),
                });
              } else if (actionMeta.action === 'select-option') {
                setExistingUmbrellaCampaignProperties({
                  ...existingUmbrellaCampaignProperties,
                  addedCampaigns: [
                    ...existingUmbrellaCampaignProperties?.addedCampaigns,
                    {
                      ID: actionMeta.option.value,
                      Name: actionMeta.option.label,
                      ClientCode: actionMeta.option.label.split('-')[1].trim(),
                    },
                  ],
                });
              } else if (actionMeta.action === 'clear') {
                setExistingUmbrellaCampaignProperties({
                  ...existingUmbrellaCampaignProperties,
                  addedCampaigns: [],
                });
              }
            }}
          ></CustomSelect>
        </InputContainer>
      </div>
    </div>
  );

  return (
    <Modal>
      <HeadModul>
        <button type="button" className="x" onClick={() => setEditCampaign(false)}>
          {' '}
          <IoMdClose className="closeIcon" />
        </button>
        <h1>Edit Campaign</h1>
        {!responseMessage ? (
          <ModulContainer>
            {isUmbrellaCampaign ? (
              // UMBRELLA CAMPAIGN EDIT - Only child campaigns management
              <>{EditUmbrellaCampaign}</>
            ) : (
              // STANDARD CAMPAIGN EDIT - Name, dates, and umbrella options
              <>
                <InputContainer>
                  <label>Campaign Name</label>
                  <input
                    type="text"
                    defaultValue={activeCampaign?.campaign}
                    onChange={(e) => setUpdateCampaignVariables({ ...updateCampaignVariables, Name: e.target.value })}
                  />
                </InputContainer>
                <InputContainer>
                  <label>Start Date</label>
                  <input
                    type="date"
                    defaultValue={activeCampaign?.startDate}
                    onChange={(e) =>
                      setUpdateCampaignVariables({ ...updateCampaignVariables, StartDate: e.target.value })
                    }
                  />
                </InputContainer>
                <InputContainer>
                  <label>End Date</label>
                  <input
                    type="date"
                    defaultValue={activeCampaign?.endDate}
                    onChange={(e) =>
                      setUpdateCampaignVariables({ ...updateCampaignVariables, EndDate: e.target.value })
                    }
                  />
                </InputContainer>
                {anyPublish && EditStandardCampaign}
              </>
            )}
            {/*                     <DarkButton style={{}} type="button" onClick={() => handleUpdateCampaign(updateCampaignVariables)}>Submit</DarkButton>
             */}{' '}
          </ModulContainer>
        ) : (
          <ModulContainer>
            <p>{responseMessage}</p>
          </ModulContainer>
        )}
        {!responseMessage && (
          <DarkButton style={{}} type="button" onClick={() => handleUpdateCampaign(updateCampaignVariables)}>
            Submit
          </DarkButton>
        )}
      </HeadModul>
    </Modal>
  );
};

export default EditCampaignModal;
